import { PATERNITY_STUDY_TYPES_ACTIONS } from "constants/Actions/PaternityStudyTypes";

// Estado inicial del reducer
const aInitialState = {
    aAllTypes: [],
    aActiveTypes: [],
    oType: null,
    nNewId: null,
    aTypesSuggestion: [],
    // Arreglos para manejar metodologias y resultados al agregar resultado en análisis clínico
    aMethodologies: null,
    aResults: null,

    bIsSuccess: false,
    bIsError: false,
}
/**
 * Reducer que será utilizado para controlar los datos referidos a los tipos de análisis clínicos que admite el sistema.
 * 
 * @param {Array} aState Estado, si no recibe datos se setea el estado inicial
 * @param {object} oAction Action que es ejecutada
 * 
 * @returns {Array} Retorna un array que sera seteado en el estado del reducer
 * 
 * @author Leandro Curbelo 
 */
export const PaternityStudyTypeReducer = (aState = aInitialState, oAction) => {
    switch (oAction.type) {
        case PATERNITY_STUDY_TYPES_ACTIONS.GET_ACTIVE:
            return { ...aState, aActiveTypes: oAction.data };
        case PATERNITY_STUDY_TYPES_ACTIONS.GET_ALL:
            return { ...aState, aAllTypes: oAction.data };
        case PATERNITY_STUDY_TYPES_ACTIONS.FIND:
            return { ...aState, oType: oAction.data };
        case PATERNITY_STUDY_TYPES_ACTIONS.SUCCESS:
            return { ...aState, bIsSuccess: true, nNewId: oAction.data };
        case PATERNITY_STUDY_TYPES_ACTIONS.ERROR:
            return { ...aState, bIsError: true };
        case PATERNITY_STUDY_TYPES_ACTIONS.CLEAN:
            return { ...aState, oType: null, bIsSuccess: false, bIsError: false, aMethodologies: null, aResults: null, nNewId: null };
        case PATERNITY_STUDY_TYPES_ACTIONS.GET_METHODOLOGIES:
            return { ...aState, aMethodologies: oAction.data };
        case PATERNITY_STUDY_TYPES_ACTIONS.GET_RESULTS:
            return { ...aState, aResults: oAction.data };
        default:
            return aState;
    }
}
